<template>
  <div v-if="activate >= 15 || activate == 11">
    <el-dropdown trigger="click" placement="bottom-start" :hide-on-click="false" @visible-change="dropdown = id">
      <el-tooltip content="タグを追加" placement="top">
        <div class="pointer flex-row" style="margin-left:10px;" v-if="list.tag != undefined && list.tag.length > 0">
          <div class="customize-tag-wrap" style="flex-wrap: nowrap;" v-html="getTag(tag_list, list.tag)">
          </div>
        </div>
        <div class="data-table-list-status-button pointer" style="padding-left: 15px;" v-else>
          <div class="list-member-user">
            <font-awesome-icon icon="tag" />
            <font-awesome-icon icon="plus-circle" class="list-member-plus" />
          </div>
        </div>
      </el-tooltip>
      <el-dropdown-menu slot="dropdown">
        <div v-if="dropdown == id">
          <el-dropdown-item
            style="font-size:12px;"
            v-for="(tag, tag_index) in tag_list"
            :key="tag.id"
            class="tag"
            @click.native="list.tag.find(lt => lt.mylist_tag_id === tag.id) ? '' : addTag(tag.id, id)"
            :class="list.tag.find(lt => lt.mylist_tag_id === tag.id) ? 'assign' : ''"
          >
            <div>{{ tag.tag_name }}</div>
            <div v-if="(tag_index = list.tag.findIndex(lt => lt.mylist_tag_id === tag.id)) !== -1">
              <div class="pointer times-circle" @click="removeTag(tag.id, tag_index, id)">
                <font-awesome-icon icon="times-circle" />
              </div>
            </div>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "listDetailDropdownTag",
  props: ["id", "list", "tag_list"],
  data() {
    return {
      dropdown: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  methods: {
    addTag(tag_id, list_id) {
      this.$emit("addTag", tag_id, list_id);
    },
    removeTag(tag_id, tag_index, list_id) {
      this.$emit("removeTag", tag_id, tag_index, list_id);
    },
    getTag(tagList, mylistTag) {
      let html = `<div class="customize-tag" style="font-size: 10px;padding:3px 8px;background-color: #dcdfe6;">`
      const selectedTag = tagList.find(tl => tl.id === mylistTag[0].mylist_tag_id)

      if (selectedTag !== undefined) {
        html += `<span style="overflow: hidden;max-width: 100px;text-overflow: ellipsis;">`
        html += selectedTag.tag_name
        html += `</span>`

        if(mylistTag.length > 1) {
          html += `</div>`
          html += `<div class="customize-tag" style="font-size: 10px;padding:3px 8px; background-color: #dcdfe6;">&plus;`
          html += mylistTag.length - 1
        }

        return html += `</div>`
      }
    }
  },
};
</script>

<style></style>
